/* hn-wissen.js — Hellas Natura Wissen Page Scripts */

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-faq-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var answer = btn.nextElementSibling;
      var arrow = btn.querySelector('.wissen-faq-arrow');
      var isOpen = !answer.hidden;
      answer.hidden = isOpen;
      arrow.classList.toggle('open', !isOpen);
      btn.setAttribute('aria-expanded', String(!isOpen));
    });
  });
});
